import * as Dialog from "@radix-ui/react-dialog";
import { useState, useEffect } from "react";

export default function PrimaryTeamModal({
  isOpen,
  onClose,
  selectedTeams = [],   // <-- Ab yahan full team objects aayengi
  onConfirm,
}) {
  const [primaryId, setPrimaryId] = useState("");

  useEffect(() => {
    if (isOpen) {
      setPrimaryId("");
    }
  }, [isOpen]);

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50" />

        <Dialog.Content
          className="bg-white p-6 rounded-md max-w-lg w-full fixed top-1/2 left-1/2 
        -translate-x-1/2 -translate-y-1/2 z-50"
        >
          <Dialog.Title className="text-lg font-semibold mb-4">
            Select Primary Team
          </Dialog.Title>
          <Dialog.Description className="sr-only">
            Choose one team as primary
          </Dialog.Description>

          {/* 🔍 DEBUG INFO */}
          <div className="text-xs text-gray-500 mb-2 p-2 bg-gray-100 rounded">
            Total Teams: {selectedTeams.length} | Selected Primary ID: {primaryId || "None"}
          </div>

          {selectedTeams.length === 0 ? (
            <p className="text-center text-gray-500">
              No teams selected
            </p>
          ) : (
            <div className="border rounded p-3 max-h-80 overflow-y-auto">
              {selectedTeams.map((t) => {
                // 🔥 MULTIPLE FIELD NAMES CHECK
                const id = String(t.id || t.teamId || t.team_id).trim();
                const name = t.team_name || t.teamName || "Unknown Team";
                const isChecked = String(primaryId) === id;

                console.log(`Team: ${name}, ID: ${id}, Checked: ${isChecked}`); // 🔍 DEBUG

                return (
                  <div
                    key={id}
                    className={`flex items-center gap-3 p-3 border-b last:border-b-0 cursor-pointer transition-colors ${
                      isChecked ? "bg-blue-50 border-l-4 border-l-blue-500" : "hover:bg-gray-100"
                    }`}
                    onClick={() => {
                      console.log("Clicked team ID:", id); // 🔍 DEBUG
                      setPrimaryId(id);
                    }}
                  >
                    <input
                      type="radio"
                      name="primaryTeam"
                      checked={isChecked}
                      onChange={(e) => {
                        e.stopPropagation();
                        setPrimaryId(id);
                      }}
                      className="w-4 h-4"
                    />
                    <div className="flex-1">
                      <span className="font-medium">{name}</span>
                      <div className="text-xs text-gray-500">
                        {t.isPrimary === "Y" && <span className="text-green-600">Current Primary</span>}
                        {t.isPrimary !== "Y" && <span>ID: {id}</span>}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="flex justify-end gap-3 mt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 transition-colors"
            >
              Cancel
            </button>

            <button
              onClick={() => {
                console.log("Confirming Primary ID:", primaryId); // 🔍 DEBUG
                onConfirm(primaryId);
              }}
              disabled={!primaryId}
              className="px-4 py-2 bg-green-600 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-green-700 transition-colors"
            >
              Confirm & Save
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}